<template>
    <nav class="absoluteBkg" :class="{'opened':open}">
      <div class="navCont" :class="{'opened':open}">
        <img src="../assets/foxbel-music.png" :class="{'opened':open}">
        <div class="linkCont" :class="{'opened':open}">
            <h1>Mi Librería</h1>
            <router-link 
                v-for="link in libraryLinks" 
                :key="link" 
                :to="{ name:`${link.name}`}"
                @click="handleOpen(false)"
            >
                {{link.text}}
            </router-link>
            <h1>Playlist</h1>
            <router-link 
                v-for="link in playlistLinks" 
                :key="link" 
                :to="{ name:`${link.name}`}"
                @click="handleOpen(false)"
            >
                {{link.text}}
            </router-link>
            <button class="closeButton" @click="handleOpen(false)">X</button>
        </div>
      </div>
    </nav>
</template>

<script>
export default {
    props:{
        open: Boolean,
        handleOpen: Function,
    },
    data(){
        return{
            libraryLinks:[
                {
                    name:'home',
                    text:'Recientes'
                },
                {
                    name:'artistas',
                    text:'Artistas'
                },
                {
                    name:'albums',
                    text:'Álbums'
                },
                {
                    name:'canciones',
                    text:'Canciones'
                },
                {
                    name:'estaciones',
                    text:'Estaciones'
                },
            ],
            playlistLinks:[
                {
                    name:'metal',
                    text:'Metal'
                },
                {
                    name:'baile',
                    text:'Para bailar'
                },
                {
                    name:'rock',
                    text:'Rock 90s'
                },
                {
                    name:'baladas',
                    text:'Baladas'
                },
            ]
        }
    }
}
</script>

<style scoped>

img{
  width: 250px;
}

nav {
  padding: 30px;
  height: 100%;
  width: 250px;
  min-height: 100vh;
  min-width: 250px;
  left: 0;
}

nav a {
  font-weight: normal;
  color: white;
  text-decoration: none;
  position: relative;
}

.absoluteBkg{ 
  background-color: #662323;
  height: 100%;
  position: fixed;
  left: 0;
  width: 310px;
}

.navCont{
  position: fixed;
}

.linkCont{
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: white;
}

nav a.router-link-exact-active {
  color: #E86060;
  font-weight: bold;
}

nav a.router-link-exact-active::before {
  content: "";
  position: absolute;
  left: 0;
  height: 100%;
  width: 8px;
  margin-left: -30px;
  background-color: #E86060;
}

.hamburger{
    display: none;
    height: 0;
}

button{
    position: absolute;
    bottom: 0;
    font-size: 30px;
    color: white;
    background-color: transparent;
    border: 0;
}
.closeButton{
    display: none;
}

@media screen
 and (max-width:880px){
    .absoluteBkg{
        width: 0;
        position: relative;
        display: block;
    }
    nav{
        width: 0;
        padding: 0;
        min-width: 0;
    }
    img{
        width: 0;
    }
    .linkCont{
        width: 0;
        overflow: hidden;
    }
    img.opened{
        width: 300px;
        margin-top: 50px;
    }
    .absoluteBkg.opened{
        width: 100%;
        position: absolute;
        z-index: 1;
    }
    .navCont.opened{
        width: 100%;
        text-align: center;
    }
    .linkCont.opened{
        display: flex;
        align-items: center;
        width: 100%;
        text-align: center;
        height: 80vh;
    }
    .closeButton{
        display: block;
    }
}

</style>